// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3ot3t","tab":"ProcedureTabs_tab__2UycK"};